module.exports = __webpack_public_path__ + "images/ktmceb9639d96d5bdd7b5bc8ff7542233e4.png";